import { RealEstateService } from './real-estate.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";


@Injectable()
export class RealEsateProjectResolver implements Resolve<any> {
  constructor(
      private realestateService:RealEstateService
  ) {
  }
  
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
      const projectid = route.params['projectid'];
      return this.realestateService.GetProjectDetails(projectid)
  }
}

@Injectable()
export class RealEsateProjectDetailsResolver implements Resolve<any> {
  constructor(
      private realestateService:RealEstateService
  ) {
  }
  
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
      const property_id = route.params['propertyid'];
      return this.realestateService.GetProjectDetails(property_id)
  }
}

@Injectable()

export class realEstateSpecificGloballyPageResolver implements Resolve<any>{

  constructor(private realestateService: RealEstateService) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const url = route.params;
    return this.realestateService.getRealEstateAwardsAndBLogs();
  }

}




// WEBPACK FOOTER //
// ./src/app/Real-Estate-Page/services/property.resolver.ts